import React, { useState, useEffect, useRef } from "react";
import APIs from "../../APIs";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  deleteItem,
  updateItemQuantity,
} from "../../redux/shipmentSlice";
import { toast } from "react-toastify";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  Polyline,
} from "@react-google-maps/api";

import Swal from "sweetalert2";
import { Toast } from "bootstrap";
import { GOOGLE_MAP_KEY } from "../../Utils/Utils";
const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "15px",
};

const Step3 = () => {
  const [isCustomBox, setIsCustomBox] = useState(false);
  const [termsChecked, setTermsChecked] = useState(true);
  const [boxes, setBoxes] = useState([]);
  const [selectedBox, setSelectedBox] = useState(null);
  const [formData, setFormData] = useState({
    itemTitle: "",
    itemWidth: "",
    itemHeight: "",
    itemLength: "",
    itemWeight: "",
    description: "",
    itemFile: null,
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [directions, setDirections] = useState(null);
  const [isMapReady, setIsMapReady] = useState(false);
  const mapRef = useRef(null);
  const { isLoaded } = useLoadScript({
    // replace with env var / safer approach for real apps
    googleMapsApiKey: GOOGLE_MAP_KEY,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pickupAddress = useSelector((state) => state.address.pickupAddress);
  const dropoffAddress = useSelector((state) => state.address.dropoffAddress);
  const items = useSelector((state) => state.shipment.items || []);
  console.log("items data for redux==", items);
  // ✅ Removed useLoadScript — not needed
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const userId = userData?.user_id;
  const [user, setUser] = useState({});
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [mapRef1, setMapRef1] = useState(null);

  useEffect(() => {
    // Retrieve saved values from sessionStorage
    const savedCategoryName = sessionStorage.getItem("categoryName");
    const savedCategoryDescription = sessionStorage.getItem(
      "categoryDescription"
    );

    if (savedCategoryName) setCategoryName(savedCategoryName);
    if (savedCategoryDescription)
      setCategoryDescription(savedCategoryDescription);
  }, []);
  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return;
      try {
        const res = await APIs.post(
          "user/getUserById",
          { user_id: userId },
          { headers: { "Content-Type": "application/json" } }
        );
        setUser(res.data?.data || {});
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };
    fetchUser();
  }, [userId]);

  // ✅ Ensure Google Maps is loaded before rendering
  useEffect(() => {
    const checkGoogleMaps = () => {
      if (window.google && window.google.maps) {
        setIsMapReady(true);
      } else {
        setTimeout(checkGoogleMaps, 300);
      }
    };
    checkGoogleMaps();
  }, []);

  // ✅ Fetch available boxes
  useEffect(() => {
    const fetchBoxes = async () => {
      try {
        const res = await APIs.get("box/getAllBox");
        if (res.data.status === "success") {
          const mapped = res.data.data.map((b) => ({
            id: b.box_id,
            box_type: b.box_type,
            width: b.box_width,
            height: b.box_height,
            length: b.box_length,
            weight: b.box_weight,
            image: b.box_image || "images/default.jpg",
            message: "",
          }));
          setBoxes(mapped);
        }
      } catch (err) {
        console.error("Error fetching boxes:", err);
      }
    };
    fetchBoxes();
  }, []);

  // ✅ Handle inputs, files, etc. (unchanged logic)
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  // ✅ Common helper function to convert File or Blob to Base64
const convertToBase64 = (fileOrBlob, callback) => {
  const reader = new FileReader();
  reader.onloadend = () => callback(reader.result);
  reader.readAsDataURL(fileOrBlob);
};

// ✅ When user uploads image manually
const handleFileChange = (e) => {
  const file = e.target.files && e.target.files[0];
  if (!file) return;

  const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
  if (!allowedTypes.includes(file.type)) {
    toast.warning("Please select a valid image file (JPG, PNG, GIF).", {
      position: "top-right",
    });
    setPreviewImage(null);
    return;
  }

  if (file.size > 5 * 1024 * 1024) {
    toast.warning("Image must be smaller than 5MB.", {
      position: "top-right",
    });
    return;
  }

  // ✅ Convert to Base64 and update state
  convertToBase64(file, (base64String) => {
    setPreviewImage(base64String);
    setFormData((prev) => ({ ...prev, itemFile: file }));
  });
};

const handleSelectBox = async (box) => {
  setSelectedBox(box);

  let file = null;
  let base64String = null;

  if (box.image) {
    try {
      const imageUrl = box.image.startsWith("http")
        ? box.image
        : `${window.location.origin}/${box.image}`;

      const response = await fetch(imageUrl);
      const blob = await response.blob();

      file = new File([blob], "box_image.jpg", { type: blob.type });
      base64String = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      setPreviewImage(base64String);
      setFormData((prev) => ({ ...prev, itemFile: file }));
    } catch (error) {
      console.error("Error loading box image:", error);
      setPreviewImage(null);
      setFormData((prev) => ({ ...prev, itemFile: null }));
    }
  } else {
    setPreviewImage(null);
    setFormData((prev) => ({ ...prev, itemFile: null }));
  }

  const custom = box.box_type?.toLowerCase() === "custom";
  setIsCustomBox(custom);

  // ✅ Important: only after image is processed, update the formData completely
  setFormData((prev) => ({
    ...prev,
    itemTitle: prev.itemTitle || box.box_type,
    itemWidth: box.width || "",
    itemHeight: box.height || "",
    itemLength: box.length || "",
    itemWeight: box.weight || "",
    description: box.message || "",
    itemFile: file, // ✅ ensure file is set AFTER fetch done
    preview: base64String || box.image || null, // ✅ keep preview consistent
  }));
};


  const validate = () => {
    const newErrors = {};
    if (!selectedBox) newErrors.box = "Please select a box";
    if (!formData.itemTitle) newErrors.itemTitle = "Item title is required";
    if (!formData.itemWidth) newErrors.itemWidth = "Width is required";
    if (!formData.itemHeight) newErrors.itemHeight = "Height is required";
    if (!formData.itemLength) newErrors.itemLength = "Length is required";
    if (!formData.itemWeight) newErrors.itemWeight = "Weight is required";
    // if (!formData.description)
    //   newErrors.description = "Description is required";
    // if (!formData.itemFile) newErrors.itemFile = "Please upload an image";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddItem = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const newItem = {
      box: selectedBox,
      itemTitle: formData.itemTitle,
      itemWidth: formData.itemWidth,
      itemHeight: formData.itemHeight,
      itemLength: formData.itemLength,
      itemWeight: formData.itemWeight,
      description: formData.description,
      preview: previewImage || selectedBox?.image || "/images/defaultImage.jpg",
      file: formData.itemFile || null, // ✅ Save Base64 instead of File object
      quantity: 1,
    };

    dispatch(addItem(newItem));

    // Reset form
    setFormData({
      itemTitle: "",
      itemWidth: "",
      itemHeight: "",
      itemLength: "",
      itemWeight: "",
      description: "",
      itemFile: null,
    });
    setPreviewImage(null);
    setSelectedBox(null);
    setErrors({});
  };

  const handleDelete = (index) => {
    Swal.fire({
      text: "Do you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        toast.success("Your item has been deleted.", { position: "top-right" });
        dispatch(deleteItem(index));
      }
    });
  };

  const handleSubmit = () => {
    if ((items || []).length === 0) {
      toast.warning("Please add at least one item before continuing", {
        position: "top-right",
      });
      return;
    }
    navigate("/Step4");
  };

  const formatAddress = (addr) =>
    addr
      ? `${addr.address || ""}, ${addr.city || ""}, ${addr.state || ""}, ${
          addr.zip_code || ""
        }`
      : "";
  const pickupLat = pickupAddress?.address_lat
    ? parseFloat(pickupAddress.address_lat)
    : null;
  const pickupLng = pickupAddress?.address_long
    ? parseFloat(pickupAddress.address_long)
    : null;
  const dropLat = dropoffAddress?.address_lat
    ? parseFloat(dropoffAddress.address_lat)
    : null;
  const dropLng = dropoffAddress?.address_long
    ? parseFloat(dropoffAddress.address_long)
    : null;

  const centerLat =
    pickupLat && dropLat
      ? (pickupLat + dropLat) / 2
      : pickupLat || dropLat || 0;
  const centerLng =
    pickupLng && dropLng
      ? (pickupLng + dropLng) / 2
      : pickupLng || dropLng || 0;

  const path =
    pickupLat && pickupLng && dropLat && dropLng
      ? [
          { lat: pickupLat, lng: pickupLng },
          { lat: dropLat, lng: dropLng },
        ]
      : [];
  const handleIncreaseQuantity = (index) => {
    const currentQty = items[index].quantity || 1;
    dispatch(updateItemQuantity({ index, quantity: currentQty + 1 }));
  };

  const handleDecreaseQuantity = (index) => {
    const currentQty = items[index].quantity || 1;
    if (currentQty > 1) {
      dispatch(updateItemQuantity({ index, quantity: currentQty - 1 }));
    }
  };

  useEffect(() => {
    if (mapRef1 && pickupLat && dropLat) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend({ lat: pickupLat, lng: pickupLng });
      bounds.extend({ lat: dropLat, lng: dropLng });
  
      mapRef1.fitBounds(bounds, {
        top: 50,
        bottom: 50,
        left: 50,
        right: 50
      });
    }
  }, [mapRef1, pickupLat, pickupLng, dropLat, dropLng]);
  return (
    <div className="page-content">
      <section className="step-section-md">
        <div className="container">
          <div className="row">
            {/* LEFT COLUMN */}
            <div className="col-lg-6">
              <div className="shipment-information-new">
                <div className="step-header">
                  <Link to="/">
                    <img
                      src="/images/logo1.jpg"
                      alt="Logo"
                      className="img-fluid"
                    />
                  </Link>
                  {user && Object.keys(user).length > 0 ? (
                    <div className="align-items-center d-flex gap-1">
                      <img
                        src={user.profile_image || "/images/user.png"}
                        alt="Profile"
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          marginLeft: "25px",
                        }}
                      />
                      <br></br>
                      <span>{user.full_name || ""}</span>
                    </div>
                  ) : (
                    <a data-bs-toggle="modal" href="#LoginModalToggle">
                      <i class="eagle-base-icon-user"></i> Sign In
                    </a>
                  )}
                </div>
                <div className="new-title">
                  <h3>{categoryName || "Important Documents"}</h3>
                  <p>
                    {categoryDescription ||
                      "Rely on us for the swift and secure transport of sensitive, time-critical documents, ensuring confidentiality and timely arrival every time."}
                  </p>
                </div>
                {/* ✅ Map Section */}
                <div
                  className="map-responsive"
                  style={{
                    borderRadius: 15,
                    overflow: "hidden",
                    border: "1px solid #c5c1c1",
                    marginTop: 15,
                    height: "400px",
                  }}
                >
                  {isLoaded ? (
                    <GoogleMap
                      mapContainerStyle={mapContainerStyle}
                      center={{ lat: centerLat, lng: centerLng }}
                      zoom={pickupLat && dropLat ? undefined : 12}
                      onLoad={(map) => setMapRef1(map)}
                    >
                      {/* Pickup Marker */}
                      {pickupLat && pickupLng && (
                        <Marker
                          position={{ lat: pickupLat, lng: pickupLng }}
                          // label={{
                          //   text: "P",
                          //   color: "#fff",
                          //   fontSize: "14px",
                          //   fontWeight: "bold",
                          // }}
                          icon={{
                            url: "/images/srcmap.png", // or full URL
                            scaledSize: new window.google.maps.Size(30, 40), // resize image
                            anchor: new window.google.maps.Point(20, 40), // bottom center
                          }}
                        />
                      )}

                      {/* Dropoff Marker */}
                      {dropLat && dropLng && (
                        <Marker
                          position={{ lat: dropLat, lng: dropLng }}
                          // label={{
                          //   text: "D",
                          //   color: "#fff",
                          //   fontSize: "14px",
                          //   fontWeight: "bold",
                          // }}
                          icon={{
                            url: "/images/destmap.png", // or full URL
                            scaledSize: new window.google.maps.Size(30, 40), // resize image
                            anchor: new window.google.maps.Point(20, 40), // bottom center
                          }}
                        />
                      )}

                      {/* Dotted Polyline between pickup and dropoff */}
                      {pickupLat && pickupLng && dropLat && dropLng && (
                        <Polyline
                          path={[
                            { lat: pickupLat, lng: pickupLng },
                            { lat: dropLat, lng: dropLng },
                          ]}
                          options={{
                            strokeOpacity: 0,
                            icons: [
                              {
                                icon: {
                                  path: "M 0,-1 0,1",
                                  strokeOpacity: 1,
                                  scale: 4,
                                },
                                offset: "0",
                                repeat: "20px", // distance between dots
                              },
                            ],
                            strokeColor: "#007bff",
                          }}
                        />
                      )}
                    </GoogleMap>
                  ) : (
                    <div style={{ padding: 20, textAlign: "center" }}>
                      Loading map...
                    </div>
                  )}
                </div>
                {/* End Map */}

                <div className="form-to-location">
                  <div className="form-location">
                    <div className="icon-ftl">
                      <i className="ti-arrow-up"></i>
                    </div>
                    <div className="flex-1">
                      <label>Pickup</label>
                      <h3>{pickupAddress?.address_type || "Home"}</h3>
                      <span>
                        {pickupAddress
                          ? formatAddress(pickupAddress)
                          : "Pickup Address"}
                      </span>
                    </div>
                    <Link to="/address?type=pickup" className="edite-icon">
                      <i className="ti-pencil"></i>
                    </Link>
                  </div>

                  <div className="to-location">
                    <div className="icon-ftl">
                      <i className="ti-arrow-down"></i>
                    </div>
                    <div className="flex-1">
                      <label>Drop-Off</label>
                      <h3>{dropoffAddress?.address_type || "Office"}</h3>
                      <span>
                        {dropoffAddress
                          ? formatAddress(dropoffAddress)
                          : "Drop-Off Address"}
                      </span>
                    </div>
                    <Link to="/address?type=dropoff" className="edite-icon">
                      <i className="ti-pencil"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="col-lg-6">
              <div className="shipment-details-new">
                <h3 className="step-count">STEP 3/5</h3>
                <form onSubmit={handleAddItem}>
                  <div className="card mb-3">
                    <div className="card-header bg-white">
                      <h5 className="mb-0">Add Items</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {/* Box Selector */}
                        <div className="col-md-12 mb-3">
                          <div className="new-select-vehical">
                            <label>Select Box</label>
                            {boxes.length === 0 ? (
                              <p>No boxes available</p>
                            ) : (
                              <ul className="nav nav-pills">
                                {boxes.map((box) => (
                                  <li className="nav-item" key={box.id}>
                                    <a
                                      href="#"
                                      className={`nav-link ${
                                        selectedBox?.id === box.id
                                          ? "active"
                                          : ""
                                      }`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleSelectBox(box);
                                      }}
                                    >
                                      <img
                                        src={box.image || "images/default.jpg"}
                                        alt={box.box_type}
                                      />
                                      <h4>{box.box_type}</h4>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>
                        {errors.box && (
                          <small
                            className="text-danger"
                            style={{ marginBottom: "20px" }}
                          >
                            {errors.box}
                          </small>
                        )}

                        {/* Item Fields */}
                        {[
                          { key: "itemTitle", label: "Item Title" },
                          { key: "itemWidth", label: "Item Width (cm)" },
                          { key: "itemHeight", label: "Item Height (cm)" },
                          { key: "itemLength", label: "Item Length (cm)" },
                          { key: "itemWeight", label: "Item Weight (kg)" },
                        ].map(({ key, label }) => (
                          <div className="col-lg-4 col-md-6" key={key}>
                            <div className="form-group">
                              <label>{label}</label>
                              <input
                                type="text"
                                className="form-control"
                                id={key}
                                value={formData[key] || ""}
                                onChange={handleChange}
                                readOnly={!isCustomBox} // ✅ Only editable when custom box selected
                                style={
                                  !isCustomBox
                                    ? {
                                        backgroundColor: "#f5f5f5",
                                        cursor: "not-allowed",
                                      }
                                    : {}
                                }
                              />

                              {errors[key] && (
                                <small className="text-danger">
                                  {errors[key]}
                                </small>
                              )}
                            </div>
                          </div>
                        ))}
                        {/* Item Image */}
                        <div className="col-lg-4 col-md-6">
                          {" "}
                          <div className="form-group mb-4">
                            {" "}
                            <label>Item Image</label>{" "}
                            <label
                              className="upload__btn"
                              style={{ cursor: "pointer" }}
                            >
                              {" "}
                              {/* ✅ Show either upload image or selected preview */}{" "}
                              {!previewImage ? (
                                <img
                                  src="images/Upload Image.png"
                                  className="img-fluid"
                                  alt="upload"
                                />
                              ) : (
                                <div className="border rounded">
                                  {" "}
                                  <img
                                    src={previewImage}
                                    alt="preview"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />{" "}
                                </div>
                              )}{" "}
                              {/* ✅ Hidden file input */}{" "}
                              <input
                                type="file"
                                id="item_image"
                                accept="image/*"
                                className="upload__inputfile"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />{" "}
                            </label>{" "}
                          </div>{" "}
                       
                        </div>

                        {/* Description */}
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Item Description</label>
                            <textarea
                              className="form-control"
                              rows="3"
                              id="description"
                              value={formData.description}
                              onChange={handleChange}
                            ></textarea>
                            {/* {errors.description && (
                              <small className="text-danger">
                                {errors.description}
                              </small>
                            )} */}
                          </div>
                        </div>

                        <div className="col-md-12">
                          <button
                            type="submit"
                            className="btn btn-dark btn-lg w-100"
                          >
                            Add Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                {/* Added Items */}
                <div className="row">
                  {items.map((it, idx) => (
                    <div className="col-md-6 mb-3" key={idx}>
                      <div className="shipment-item-container">
                        <div className="shipment-item-img">
                          {/* <img
                            src={it.previewImage || it.preview || "images/default.jpg"}
                            className="img-fluid"
                            alt={it.itemTitle || "Item"}
                            style={{ height: "100%", objectFit: "cover" }}
                          /> */}
                          <img
                            src={
                              it.previewImage && it.previewImage.trim() !== ""
                                ? it.previewImage
                                : it.preview && it.preview.trim() !== ""
                                ? it.preview
                                : "/images/defaultImage.jpg" // ✅ fallback image path
                            }
                            className="img-fluid"
                            alt={it.itemTitle || "Item"}
                            style={{ height: "100%", objectFit: "cover" }}
                            onError={(e) => {
                              // ✅ handles broken or invalid image URLs
                              e.target.onerror = null;
                              e.target.src = "/images/defaultImage.jpg";
                            }}
                          />
                        </div>

                        <div className="shipment-item-details">
                          <h5>{it.box?.box_type}</h5>
                          <p className="small mb-1">{it.description}</p>
                          <p className="small mb-1">
                            Size: {it.itemHeight} cm × {it.itemWidth} cm ×{" "}
                            {it.itemLength} cm
                          </p>
                          <p className="small mb-1">
                            Box Weight: {it.itemWeight} kg
                          </p>

                          {/* ✅ Quantity controls */}
                          <div
                            className="d-flex align-items-center gap-2 mt-2"
                            style={{
                              float: "right",
                              border: "rgba(211, 206, 206, 1)4e4",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => handleDecreaseQuantity(idx)}
                            >
                              –
                            </button>
                            <span
                              style={{ minWidth: "30px", textAlign: "center" }}
                            >
                              {it.quantity || 1}
                            </span>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => handleIncreaseQuantity(idx)}
                            >
                              +
                            </button>
                          </div>
                        </div>

                        <a
                          href="#"
                          className="delet-icon"
                          onClick={(e) => {
                            e.preventDefault();
                            handleDelete(idx);
                          }}
                        >
                          <i className="ti-trash"></i>
                        </a>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="alert alert-success" role="alert">
                  <i className="fa fa-exclamation-triangle"></i> Air shipments
                  are subject to carrier schedules and customs clearance;
                  prohibited, illegal, and hazardous/chemical goods are not
                  accepted
                </div>

                <div className="form-group mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexCheckChecked"
                      checked={termsChecked}
                      onChange={() => setTermsChecked(!termsChecked)}
                    />
                    <label
                      className="form-check-label terms-conditions"
                      htmlFor="flexCheckChecked"
                    >
                      I Agree with all the <a href="https://eagleobc.com/privacy-policy" target="_blank">Terms & conditions</a>
                    </label>
                  </div>
                </div>

                <div className="button-wraper-new">
                  <button
                    type="button"
                    onClick={() => navigate("/Step2")}
                    className="btn btn-dark btn-lg"
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-success btn-lg flex-1"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Step3;
